import { TrackingData } from '../useTracking';
import { getPageViewPayload } from '../utils/getPageViewPayload';

export function pageView(trackingData: TrackingData) {
  const pageViewPayload = getPageViewPayload(trackingData);
  window.analytics?.page({
    ...pageViewPayload,
  }); // Send page view event
}
